import React from 'react';

const SubFlowHeading = ({ headingTitle, headingSubTitle }) => (
    <h1>
        {headingTitle}
        :&nbsp;
        {headingSubTitle}
    </h1>
);

export default SubFlowHeading;
